import styled from 'styled-components';

// CONSTANTS
import { SANTAS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const SRegistrationSuccessTemplate = styled.div`
  .ext-link-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    p {
      margin-top: 4px;
      text-align: center;
      color: ${SANTAS_GRAY};
    }
  }

  ${breakpoints.down('sm')} {
    .MuiButton-root,
    .MuiGrid-item {
      width: 100%;
    }
  }

  ${breakpoints.up('sm')} {
    .ext-link-wrapper {
      flex-direction: row;

      p {
        margin-top: 0;
        margin-left: 8px;
        max-width: 220px;
        text-align: left;
      }
    }

    .MuiButton-root {
      max-height: 50px;
      width: 160px;

      &.type-vimeo {
        width: 200px;
      }
    }

    &.type-vimeo {
      .MuiButton-root {
        width: 200px;
      }
    }
  }
`;

export default SRegistrationSuccessTemplate;
